// @generated by protoc-gen-es v2.10.0 with parameter "target=ts,import_extension=none"
// @generated from file proto/sem/middleware/next_thinking_mode.proto (package sem.middleware.next_thinking_mode, syntax proto3)
/* eslint-disable */

import type { Message } from "@bufbuild/protobuf";
import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/sem/middleware/next_thinking_mode.proto.
 */
export const file_proto_sem_middleware_next_thinking_mode: GenFile = /*@__PURE__*/
  fileDesc("Ci1wcm90by9zZW0vbWlkZGxld2FyZS9uZXh0X3RoaW5raW5nX21vZGUucHJvdG8SIXNlbS5taWRkbGV3YXJlLm5leHRfdGhpbmtpbmdfbW9kZSJOChdOZXh0VGhpbmtpbmdNb2RlUGF5bG9hZBIMCgRtb2RlGAEgASgJEhEKCXJlYXNvbmluZxgCIAEoCRISCgpjb25maWRlbmNlGAMgASgJInQKF05leHRUaGlua2luZ01vZGVTdGFydGVkEg8KB2l0ZW1faWQYASABKAkSSAoEZGF0YRgCIAEoCzI6LnNlbS5taWRkbGV3YXJlLm5leHRfdGhpbmtpbmdfbW9kZS5OZXh0VGhpbmtpbmdNb2RlUGF5bG9hZCJzChZOZXh0VGhpbmtpbmdNb2RlVXBkYXRlEg8KB2l0ZW1faWQYASABKAkSSAoEZGF0YRgCIAEoCzI6LnNlbS5taWRkbGV3YXJlLm5leHRfdGhpbmtpbmdfbW9kZS5OZXh0VGhpbmtpbmdNb2RlUGF5bG9hZCKWAQoZTmV4dFRoaW5raW5nTW9kZUNvbXBsZXRlZBIPCgdpdGVtX2lkGAEgASgJEkgKBGRhdGEYAiABKAsyOi5zZW0ubWlkZGxld2FyZS5uZXh0X3RoaW5raW5nX21vZGUuTmV4dFRoaW5raW5nTW9kZVBheWxvYWQSDwoHc3VjY2VzcxgDIAEoCBINCgVlcnJvchgEIAEoCUJWWlRnaXRodWIuY29tL3RlYW0tbWVudG8vbWVudG8tcGxheWdyb3VuZC9nby9wa2cvc2VtL3BiL3Byb3RvL3NlbS9taWRkbGV3YXJlO21pZGRsZXdhcmViBnByb3RvMw");

/**
 * @generated from message sem.middleware.next_thinking_mode.NextThinkingModePayload
 */
export type NextThinkingModePayload = Message<"sem.middleware.next_thinking_mode.NextThinkingModePayload"> & {
  /**
   * @generated from field: string mode = 1;
   */
  mode: string;

  /**
   * @generated from field: string reasoning = 2;
   */
  reasoning: string;

  /**
   * @generated from field: string confidence = 3;
   */
  confidence: string;
};

/**
 * Describes the message sem.middleware.next_thinking_mode.NextThinkingModePayload.
 * Use `create(NextThinkingModePayloadSchema)` to create a new message.
 */
export const NextThinkingModePayloadSchema: GenMessage<NextThinkingModePayload> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_next_thinking_mode, 0);

/**
 * @generated from message sem.middleware.next_thinking_mode.NextThinkingModeStarted
 */
export type NextThinkingModeStarted = Message<"sem.middleware.next_thinking_mode.NextThinkingModeStarted"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.next_thinking_mode.NextThinkingModePayload data = 2;
   */
  data?: NextThinkingModePayload;
};

/**
 * Describes the message sem.middleware.next_thinking_mode.NextThinkingModeStarted.
 * Use `create(NextThinkingModeStartedSchema)` to create a new message.
 */
export const NextThinkingModeStartedSchema: GenMessage<NextThinkingModeStarted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_next_thinking_mode, 1);

/**
 * @generated from message sem.middleware.next_thinking_mode.NextThinkingModeUpdate
 */
export type NextThinkingModeUpdate = Message<"sem.middleware.next_thinking_mode.NextThinkingModeUpdate"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.next_thinking_mode.NextThinkingModePayload data = 2;
   */
  data?: NextThinkingModePayload;
};

/**
 * Describes the message sem.middleware.next_thinking_mode.NextThinkingModeUpdate.
 * Use `create(NextThinkingModeUpdateSchema)` to create a new message.
 */
export const NextThinkingModeUpdateSchema: GenMessage<NextThinkingModeUpdate> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_next_thinking_mode, 2);

/**
 * @generated from message sem.middleware.next_thinking_mode.NextThinkingModeCompleted
 */
export type NextThinkingModeCompleted = Message<"sem.middleware.next_thinking_mode.NextThinkingModeCompleted"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.next_thinking_mode.NextThinkingModePayload data = 2;
   */
  data?: NextThinkingModePayload;

  /**
   * @generated from field: bool success = 3;
   */
  success: boolean;

  /**
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message sem.middleware.next_thinking_mode.NextThinkingModeCompleted.
 * Use `create(NextThinkingModeCompletedSchema)` to create a new message.
 */
export const NextThinkingModeCompletedSchema: GenMessage<NextThinkingModeCompleted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_next_thinking_mode, 3);

